<template>
    <div class="page linkman-edit">
        <!-- 头部 -->
        <head-bar :title="headTitle" :fixed="true"> </head-bar>
        <!-- 内容 -->
        <div class="content">
            <div class="form-box">
                <van-field
                    v-model="form.linkmanName"
                    label="收货人"
                    placeholder="请输入收货人名"
                    maxlength="8"
                />
                <van-field
                    v-model="form.linkmanPhone"
                    label="电话号码"
                    type="tel"
                    placeholder="请输入电话号码"
                    maxlength="11"
                />
                <div class="space-box">
                    <van-cell center title="设为默认">
                        <van-switch
                            v-model="form.defaultFlag"
                            active-color="#96EB7C"
                            inactive-color="#EDEDED"
                            slot="right-icon"
                            size="24"
                        />
                    </van-cell>
                </div>
                <div class="info-form-button">
                    <van-button
                        type="primary"
                        :loading="submitLoading"
                        loading-text="正在保存..."
                        @click="submitForm"
                        size="large"
                        round
                    >
                        保存
                    </van-button>
                    <van-button
                        type="danger"
                        v-if="query.id"
                        :loading="delLoading"
                        loading-text="正在删除..."
                        @click="handleDel"
                        size="large"
                        round
                    >
                        删除
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HeadBar from "../../../components/HeadBar.vue";
import { isEmpty, isPhone } from "../../../utils/validation";
import Vue from "vue";
import { Field, Switch, Cell, Button, Dialog } from "vant";
import utils from "../../../utils/utils";

Vue.use(Field);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Button);

export default {
    name: "LinkmanAdd",
    components: { HeadBar },
    data() {
        return {
            /* 路由参数 */
            query: {
                id: this.$route.query.id,
            },
            /* 表单数据 */
            form: {
                linkmanName: "", // 收货人
                linkmanPhone: "", // 电话号码
                defaultFlag: true, // 设为默认
            },
            submitLoading: false, // 保存loading
            delLoading: false, // 删除loading
        };
    },
    computed: {
        /* 页面标题 */
        headTitle() {
            const title = this.query.id ? "编辑下单联系人" : "新增下单联系人";
            return title;
        },
    },
    created() {
        if (this.query.id) this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            const _this = this;
            const url = this.$api.userApi.queryLinkmanById;
            const params = {
                operation: "select",
                context: {
                    linkmanId: this.query.id,
                },
            };
            _this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios
                .post(url, params)
                .then((res) => {
                    let { data: linkmanInfo = {} } = res;
                    this.form = { ...linkmanInfo };
                })
                .finally(() => {
                    _this.$toast.clear();
                });
        },
        /* 保存 */
        submitForm() {
            if (!this.validate()) return;
            this.linkmanOperate();
        },
        /* 创建 || 修改 联系人信息 */
        linkmanOperate() {
            const url = this.$api.userApi.linkmanApi;
            // 参数对象
            const params = {
                operation: this.query.id ? "update" : "create",
                context: this.form,
            };

            this.submitLoading = true;
            this.$axios
                .post(url, params)
                .then((res) => {
                    this.submitLoading = false;
                    this.$toast.success("保存成功");

                    this.$router.go(-1);
                })
                .catch((err) => {
                    this.submitLoading = false;
                });
        },
        /* 校验表单 */
        validate() {
            const { linkmanName, linkmanPhone } = this.form;
            if (isEmpty(utils.trim(linkmanName))) {
                this.$toast("收货人不能为空");
                return false;
            } else if (!isPhone(linkmanPhone)) {
                this.$toast("请输入正确的手机号码");
                return false;
            }
            return true;
        },
        /* 删除 */
        handleDel() {
            Dialog.confirm({
                title: "提示",
                message: "是否确认删除?",
                confirmBUttonColor: "#4BC227",
            })
                .then(() => {
                    const url = this.$api.userApi.linkmanApi;
                    const params = {
                        operation: "delete",
                        context: {
                            linkmanId: this.query.id,
                        },
                    };

                    this.delLoading = true;
                    this.$axios
                        .post(url, params)
                        .then((res) => {
                            this.delLoading = false;
                            this.$toast.success("删除成功");
                            this.$router.go(-1);
                        })
                        .catch((err) => {
                            this.delLoading = false;
                        });
                })
                .catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
.linkman-edit {
    .content {
        padding-top: 20px;

        .form-box {
            .space-box {
                margin: 20px auto 60px;
            }

            .info-form-button {
                padding: 0 30px;

                .van-button {
                    margin-bottom: 30px;
                }
            }
        }
    }
}
</style>
